import styled from '@emotion/styled';

export const ImageItemWrapper = styled.button(({ theme }) => ({
    background: theme.colors.productImageBackround,
    border: `1px solid ${theme.colors.brownLight}`,
    margin: 0,
    padding: 0,
    cursor: 'pointer',
    display: 'block',
    aspectRatio: 1,

    ':focus-visible': {
        boxShadow: theme.shadows.accessibility,
    },

    '> div': {
        width: '100%',
        height: '100%',
    },
    '> div > div': {
        width: '100%',
        height: '100%',
        '> img:first-of-type': {
            objectFit: 'cover',
            width: '100%',
            height: '100%',
            mixBlendMode: 'multiply',
        },
    },
}));
